import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQ8o5HwnolzMyh5KJ4QSTaJqJ6VQJ-V5o",
  authDomain: "alec-aar-91288.firebaseapp.com",
  projectId: "alec-aar-91288",
  storageBucket: "alec-aar-91288.firebasestorage.app",
  messagingSenderId: "892551850471",
  appId: "1:892551850471:web:901b9cb837b29da71c3542",
};

export const fb = initializeApp(firebaseConfig);
